// extracted by mini-css-extract-plugin
module.exports = {"singleCard":"SingleCard_singleCard__wXnNB"};